<h2 class="dialog-content text-header" mat-dialog-title>Error</h2>
<mat-dialog-content class="mat-content">
    {{ data.message }}
</mat-dialog-content>
<mat-dialog-actions class="dialog-content">
    <button mat-button mat-dialog-close class="margin-auto" (click)="closeErrorPopup()">OK</button>
</mat-dialog-actions>